import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=1d8a9312&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=1d8a9312&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a9312",
  null
  
)

export default component.exports